import React from 'react';
import { useNewPassword } from './useNewPassword';
import { Label } from '../../../components/Label';
import { Text } from '../../../components/Text';
import { InputText } from '../../../components/InputText';
import { Button } from '../../../components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const NewPassword = (props) => {
  const {
    loading,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    notMatch,
    handleUpdate,
    finished,
  } = useNewPassword(props);

  const renderForm = () => (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '10px',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h4 style={{ margin: 0 }}>
          <b>Redefinição de Senha</b>
        </h4>
        <p style={{ fontSize: '0.875rem', margin: 0 }}>
          Insira abaixo a sua nova senha:
        </p>
      </div>
      <div style={{ marginTop: '15px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            height: '100%',
          }}
        >
          <Label required>Senha</Label>
          <Text color="red400" size="xs">
            Mín. 6 caracteres
          </Text>
        </div>
        <InputText
          name="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          maxLength="18"
          type="password"
          isLoading={loading}
        />

        <Label required>Confirme a Senha</Label>
        <InputText
          name="confirmPassword"
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          maxLength="18"
          type="password"
          isLoading={loading}
          error={notMatch ? 'As senhas não coindidem' : null}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '15px',
        }}
      >
        <Button
          onClick={handleUpdate}
          color="green450"
          disabled={
            loading || password.length < 6 || confirmPassword.length < 6
          }
        >
          Alterar Senha
          {loading && (
            <span
              className="fa fa-spinner fa-pulse fa-1x"
              style={{ marginLeft: '5px' }}
            />
          )}
        </Button>
      </div>
    </>
  );

  const renderFinishedScreen = () => (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '10px',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h4 style={{ margin: 0 }}>
          <b>Senha alterada com sucesso</b>{' '}
          <FontAwesomeIcon color="#28A745" icon={faCheckCircle} />
        </h4>
        <p style={{ fontSize: '0.875rem', margin: '8px 0 0 0' }}>
          Clique no botão abaixo e acesse com a sua nova senha
        </p>
      </div>
      <br />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '15px',
        }}
      >
        <Button onClick={() => props.handleOption(0)} color="green450">
          Voltar para a tela principal
        </Button>
      </div>
    </>
  );

  return (
    <div style={{ width: '100%' }}>
      <div>
        <div>{finished ? renderFinishedScreen() : renderForm()}</div>
        <br />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Text
            color="red400"
            size="xs"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            Em caso de dúvidas ou problemas, contate o&thinsp;
            <a href="mailto:ouvidoria@sobrerodas.club">
              ouvidoria@sobrerodas.club
            </a>
          </Text>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
